export class ForcedCheckinResult {
    glid: string;
    name: string;
    nbForcedCheckin: number;
    latitude: number;
    longitude: number;

  static fromDto(p: any): ForcedCheckinResult {
    const res = new ForcedCheckinResult();

    res.glid = p.glid;
    res.name = p.name;
    res.nbForcedCheckin = p.nb_forced_checkins;
    res.latitude = p.latitude;
    res.longitude = p.longitude;

    return res;
  }

  static entitiesFromDto(p: any): ForcedCheckinResult[] {
    const res = [];
    p.forEach(dto => {
      res.push(this.fromDto(dto));
    })
    return res;
  }
}
